
const FeaturedSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Logo Image */}
          <div className="order-2 lg:order-1">
            <div className="bg-gray-50 rounded-3xl p-12 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/4083781e1a34b23bac118fadb1fef617.png"
                alt="خياط الأقمشة الكويتية"
                className="w-full max-w-md h-auto object-contain"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-4xl font-bold text-accent mb-6">أقمشتنا المميزة</h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              نقدم لكم أفضل وأجود أنواع الأقمشة المستوردة من اليابان، كوريا، إندونيسيا، الهند والصين. جميع أقمشتنا مختارة بعناية فائقة لضمان الجودة العالية والراحة التامة.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-gray-50 p-6 rounded-2xl">
                <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-star-line text-2xl text-secondary"></i>
                </div>
                <h3 className="text-xl font-bold text-accent mb-2">أقمشة مستوردة</h3>
                <p className="text-gray-600">من أفضل المصانع العالمية</p>
              </div>

              <div className="bg-gray-50 p-6 rounded-2xl">
                <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-secondary"></i>
                </div>
                <h3 className="text-xl font-bold text-accent mb-2">جودة عالية</h3>
                <p className="text-gray-600">ضمان الجودة والمتانة</p>
              </div>
            </div>

            <a
              href="/fabrics"
              className="inline-block bg-secondary text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-opacity-90 transition-all cursor-pointer whitespace-nowrap"
            >
              عرض جميع الأقمشة
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSection;
